import React from 'react'
import withStyles from 'constructicon/with-styles'
import styles from './styles'
import LinkHandler from '../../../utils/LinkHandler'

const Charity = ({
  classNames,
  image,
  name,
  url
}) => (
  <LinkHandler to={url} className={classNames.link}>
    <img
      src={image}
      alt={name}
      className={classNames.image}
    />
  </LinkHandler>
)

export default withStyles(styles)(Charity)



// WEBPACK FOOTER //
// ./components/slices/FeaturedCharities/Charity/index.js